/* Import main CSS modules */
import '../css/critical.scss';
import '../css/main.scss';
